import { Steps } from 'antd'
import styled from 'styled-components'

export const FooterDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 0px 20px;
`
export const StepTitle = styled.div`
  display: flex;
  font-size: 1em;
  font-weight: 500;
`

export const StyledSteps = styled(Steps)`
  & .ant-steps-item-title {
    width: fit-content;
  }
  padding-bottom: 60px;
`
export const StepIconStyle = {
  background: 'green',
  borderRadius: '100%',
}

export const FormContainer = styled.div``
